import { Image, Upload } from 'antd';
import { useState, useEffect } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import axios from 'axios';

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

const LogoUpload = () => {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState([]);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchLogo = async () => {
            try {
                const token = JSON.parse(localStorage.getItem('loginToken'));
                const endpoint = `${process.env.REACT_APP_BASE_URL}/user/companylogo`;

                const response = await axios({
                    method: 'GET',
                    url: endpoint,
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                })

                if (response.data && response.data.message && response.status === 200) {
                    localStorage.setItem('logoUrl', JSON.stringify(response?.data?.message));
                    setFileList([
                        {
                            uid: '-1',
                            name: 'logo.jpg',
                            status: 'done',
                            url: response.data.message,
                        },
                    ]);
                }
            } catch (error) {
                console.error('Failed to fetch logo', error);
            }
        };

        fetchLogo();
    }, []);

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || (file.preview));
        setPreviewOpen(true);
    };

    const handleChange = ({ fileList: newFileList }) => {
        if (error) {
            setError(false)
            return
        }
        setFileList(newFileList);
    }

    const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </button>
    );

    const handleUpload = async ({ file, onSuccess, onError, onProgress }) => {
        const formData = new FormData();
        formData.append('image', file);
        const endpoint = `${process.env.REACT_APP_BASE_URL}/user/companylogo`;
        const token = JSON.parse(localStorage.getItem('loginToken'));

        try {
            const response = await axios({
                method: 'POST',
                url: endpoint,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`,
                },
                data: formData,
                onUploadProgress: (progressEvent) => {
                    if (onProgress) {
                        onProgress({
                            percent: Math.round((progressEvent.loaded * 100) / progressEvent.total),
                        });
                    }
                },
            });
            localStorage.setItem('logoUrl', JSON.stringify(response?.data?.user?.companyLogo));
            onSuccess(response.data, file);
        } catch (error) {
            onError(error);
            console.error('Upload failed');
        }
    };

    const handleRemove = async (file) => {
        return new Promise((resolve, reject) => {
            const confirmDelete = window.confirm("Are you sure you want to remove the company logo?");

            if (!confirmDelete) {
                reject();
                return;
            }

            const endpoint = `${process.env.REACT_APP_BASE_URL}/user/companylogo`;
            const token = JSON.parse(localStorage.getItem('loginToken'));

            axios({
                method: 'DELETE',
                url: endpoint,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(() => {
                    setFileList((prevFileList) => prevFileList.filter((item) => item.uid !== file.uid));
                    localStorage.removeItem('logoUrl');
                    console.log('File Deleted Successfully');
                    resolve();
                })
                .catch((error) => {
                    console.log('File Delete Failed', error);
                    reject();
                });
        });
    };


    const beforeUpload = (file) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        const isSmallEnough = file.size / 1024 / 1024 < 2; // Check if file size is less than 2MB

        if (!isJpgOrPng) {
            setError(true)
            alert('You can only upload JPG/PNG file!');
        }
        if (!isSmallEnough) {
            setError(true)
            alert('Image must be smaller than 2MB!');
        }

        return isJpgOrPng && isSmallEnough; // Allow upload only if both conditions are met
    };

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div>
                    <Upload
                        customRequest={handleUpload}
                        listType="picture-card"
                        fileList={fileList}
                        onPreview={handlePreview}
                        onChange={handleChange}
                        onRemove={handleRemove}
                        beforeUpload={beforeUpload}
                    >
                        {fileList.length >= 1 ? null : uploadButton}
                    </Upload>

                    {previewImage && (
                        <Image
                            wrapperStyle={{ display: 'none' }}
                            preview={{
                                visible: previewOpen,
                                onVisibleChange: (visible) => setPreviewOpen(visible),
                                afterOpenChange: (visible) => !visible && setPreviewImage(''),
                            }}
                            src={previewImage}
                        />
                    )}
                </div>
                <div style={{ marginLeft: '10px' }}>
                    <h3>Company Logo</h3>
                    <p>We recommend using a logo with a white background for prominent display and printing purpose. Please use only JPG or PNG formats. The recommended minimum size is 200 pixels in width or height.</p>
                </div>

            </div>
        </>
    );
};

export default LogoUpload;
